// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"bf34dd49","40":"3c63f8a5","117":"0c4c9027","289":"e99ba3ab","401":"5f3eed34","453":"11fe5cfd","830":"eb4788d6","908":"b2b8ed20","947":"036c0a8a","999":"329129d8"}[chunkId] + ".chunk.js";
};